import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { SectionWrapper } from './SectionWrapper';
const approaches = [{
  title: 'El Sermón Lógico',
  desc: 'Tu hijo desconecta el cerebro a los 10 segundos porque lo siente como una invasión a su inteligencia.'
}, {
  title: 'La Empatía Forzada',
  desc: "Intentar ser su 'mejor amigo' se siente falso y hace que él pierda el respeto por tu figura de autoridad."
}, {
  title: 'El Castigo por Enojó',
  desc: 'Quitar el celular en medio de un grito solo genera resentimiento a largo plazo y no cambia la conducta de fondo.'
}, {
  title: 'El Interrogatorio',
  desc: "Preguntar '¿Cómo te fue?' suena a reporte policial, no a interés genuino, y por eso responde con 'nada' o 'bien'."
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function FailedApproachesSection() {
  return <SectionWrapper altBg data-id="element-24">
      <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-12 text-center" data-id="element-25">
        Por qué lo que has intentado no funciona
      </h2>

      <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
      once: true,
      margin: '-50px'
    }} className="space-y-6" data-id="element-26">
        {approaches.map((item, index) => <motion.div key={index} variants={itemVariants} className="flex items-start p-6 bg-card rounded-sm shadow-warm border border-subtle" data-id="element-27">
            <div className="flex-shrink-0 mt-1" data-id="element-28">
              <XIcon className="w-6 h-6 text-amber/80" data-id="element-29" />
            </div>
            <div className="ml-4" data-id="element-30">
              <h3 className="text-xl font-heading font-semibold text-primary mb-2" data-id="element-31">
                {item.title}
              </h3>
              <p className="text-secondary font-body leading-relaxed" data-id="element-32">
                {item.desc}
              </p>
            </div>
          </motion.div>)}
      </motion.div>
    </SectionWrapper>;
}